export default __webpack_public_path__ + "static/media/creative-agency.3ebd3d41.PNG";